var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('h1',[_vm._v("Consulta masiva de Folios VUR (máximo 50)")]),_c('vur-massive-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }